import { createAction } from '@ngrx/store';

export const loadUsers = createAction(
    '[Transaction Queue] Load Users'
);
